<template>
  <div class="bulk-order-orderer-detail-new">
    <div class="bulk-order-orderer-detail-new__container">
      <div class="bulk-order-orderer-detail-new__header-container">
        <PageHeadlineForBulkOrder
          title="お客様情報入力"
          :step="2"
          class="bulk-order-orderer-detail-new__header-title"
        />
      </div>
      <Form
        v-slot="{ errorBag, meta }"
        class="bulk-order-orderer-detail-new__form"
      >
        <form
          id="orderer-detail-new-form"
          name="orderer_detail_new_form"
          action="/bulk_order/orderer_detail"
          accept-charset="UTF-8"
          method="post"
        >
          <input type="hidden" name="_method" value="patch" />
          <input type="hidden" name="authenticity_token" :value="csrfToken()" />
          <div class="bulk-order-orderer-detail-new__contents-container">
            <div class="bulk-order-orderer-detail-new__form-contents">
              <BoxListAlert v-if="errorMessages.length !== 0" class="mb-16">
                <p v-for="(msg, index) in errorMessages" :key="index">
                  {{ msg }}
                </p>
              </BoxListAlert>
              <p class="minimal-danger mb-24">
                必須*
              </p>
              <div class="mb-24">
                <HeadlineFormTitle title="お名前" required class="mb-16" />
                <div>
                  <p class="minimal mb-16">
                    請求書の宛名に利用いたします
                  </p>
                </div>
                <div class="bulk-order-orderer-detail-new__orderer-name mb-8">
                  <InputFormText
                    id="bulk_order_orderer_last_name"
                    :value="lastName"
                    placeholder="ギフティ"
                    name="orderer_detail_form[last_name]"
                    max-length="255"
                    rules="required|max:255"
                    :show-error-messages="false"
                    @input="e => setLastName(e.target.value)"
                  />
                  <InputFormText
                    id="bulk_order_orderer_first_name"
                    :value="firstName"
                    placeholder="太郎"
                    name="orderer_detail_form[first_name]"
                    max-length="255"
                    rules="required|max:255"
                    :show-error-messages="false"
                    @input="e => setFirstName(e.target.value)"
                  />
                </div>
                <ErrorMessages
                  :errors="errorBag['orderer_detail_form[last_name]']"
                  as="p"
                />
                <ErrorMessages
                  :errors="errorBag['orderer_detail_form[first_name]']"
                  as="p"
                />
              </div>
              <div class="mb-24">
                <HeadlineFormTitle
                  title="メールアドレス"
                  required
                  class="mb-16"
                />
                <p class="minimal mb-16">
                  メールアドレスを正しく入力いただいていない場合、gifteeからの返信が届きませんのでご注意ください
                </p>
                <div
                  class="bulk-order-orderer-detail-new__email-form-container mb-8"
                >
                  <InputFormText
                    id="bulk_order_orderer_email"
                    :value="email"
                    placeholder="メールアドレス"
                    type="email"
                    name="orderer_detail_form[email]"
                    autocomplete="email"
                    max-length="255"
                    rules="required|email|max:255"
                    :show-error-messages="false"
                    @input="e => setEmail(e.target.value)"
                  />
                  <InputFormText
                    id="bulk_order_orderer_email_confirm"
                    :value="emailConfirm"
                    placeholder="メールアドレス（確認）"
                    type="email"
                    name="orderer_detail_form[email_confirm]"
                    autocomplete="email"
                    max-length="255"
                    rules="required|email|max:255|confirmed:@orderer_detail_form[email]"
                    :show-error-messages="false"
                    @input="e => setEmailConfirm(e.target.value)"
                  />
                </div>
                <ErrorMessages
                  :errors="errorBag['orderer_detail_form[email]']"
                  as="p"
                />
                <ErrorMessages
                  :errors="errorBag['orderer_detail_form[email_confirm]']"
                  as="p"
                />
              </div>
              <div class="mb-24">
                <HeadlineFormTitle title="郵便番号" required class="mb-16" />
                <p class="minimal mb-16">
                  数字7ケタ、ハイフンなしでご入力ください
                </p>
                <InputFormText
                  id="bulk_order_orderer_zip_code"
                  class="mb-8"
                  :value="zipcode"
                  placeholder="1234567"
                  name="orderer_detail_form[zipcode]"
                  max-length="7"
                  rules="zipcode|digits:7|required"
                  @input="e => onChangeZipcode(e)"
                />
              </div>
              <div class="mb-24">
                <HeadlineFormTitle title="住所" required class="mb-16" />
                <div
                  class="bulk-order-orderer-detail-new__address-form-container mb-8"
                >
                  <SelectForm
                    id="bulk_order_orderer_prefecture_id"
                    :value="prefectureId"
                    name="orderer_detail_form[prefecture_id]"
                    autocomplete="shipping address-level1"
                    rules="required"
                    :show-error-messages="false"
                    @input="e => setPrefectureId(e.target.value)"
                  >
                    <option disabled value="">
                      都道府県
                    </option>
                    <option
                      v-for="p in props.prefectures"
                      :key="p.id"
                      :value="p.id"
                    >
                      {{ p.name }}
                    </option>
                  </SelectForm>
                  <InputFormText
                    id="bulk_order_orderer_address1"
                    :value="address1"
                    placeholder="市区町村"
                    name="orderer_detail_form[address1]"
                    autocomplete="shipping address-line1"
                    max-length="255"
                    rules="required|max:255"
                    :show-error-messages="false"
                    @input="e => setAddress1(e.target.value)"
                  />
                  <InputFormText
                    id="bulk_order_orderer_address2"
                    :value="address2"
                    placeholder="番地・建物名"
                    name="orderer_detail_form[address2]"
                    autocomplete="shipping address-line2"
                    max-length="255"
                    rules="required|max:255"
                    :show-error-messages="false"
                    @input="e => setAddress2(e.target.value)"
                  />
                </div>
                <ErrorMessages
                  :errors="errorBag['orderer_detail_form[prefecture_id]']"
                  as="p"
                />
                <ErrorMessages
                  :errors="errorBag['orderer_detail_form[address1]']"
                  as="p"
                />
                <ErrorMessages
                  :errors="errorBag['orderer_detail_form[address2]']"
                  as="p"
                />
              </div>
              <div class="mb-24">
                <HeadlineFormTitle title="電話番号" required class="mb-16" />
                <p class="minimal mb-16">
                  ハイフンなしでご入力ください
                </p>
                <InputFormText
                  id="bulk_order_orderer_phone_number"
                  :value="phoneNumber"
                  placeholder="09000000000"
                  type="tel"
                  name="orderer_detail_form[phone_number]"
                  autocomplete="tel-national"
                  max-length="11"
                  rules="required|phone_length|numeric"
                  @input="e => setPhoneNumber(e.target.value)"
                />
              </div>
              <div class="mb-24">
                <HeadlineFormTitle
                  title="振込み人名義（カナ）"
                  required
                  class="mb-16"
                />
                <div class="mb-16">
                  <p class="minimal">
                    お申し込みご本人様のお名前と振込み名義は同一となるようお申し込みください。
                  </p>
                  <p class="minimal">
                    ご入力いただいた振込み名義と別の名義でのお振り込みは絶対に行わないでください。
                  </p>
                  <p class="minimal">
                    個人のお客様向けお申し込みで振り込みを法人様名義とすることはできません。
                  </p>
                </div>
                <InputFormText
                  id="bulk_order_orderer_payer_full_name_kana"
                  :value="payerFullNameKana"
                  placeholder="ギフティ タロウ"
                  name="orderer_detail_form[payer_full_name_kana]"
                  autocomplete="off"
                  max-length="255"
                  rules="required|katakana_name|max:255"
                  @input="e => setPayerFullNameKana(e.target.value)"
                />
              </div>
              <div class="mb-24">
                <HeadlineFormTitle
                  title="利用目的の詳細"
                  required
                  class="mb-16"
                />
                <InputFormTextArea
                  id="bulk_order_orderer_purpose_of_use"
                  :value="purposeOfUse"
                  :placeholder="
                    `利用目的をご入力ください\n例）結婚式にご参列いただくゲストへのプチギフトを用意するため`
                  "
                  name="orderer_detail_form[purpose_of_use]"
                  autocomplete="off"
                  max-length="1000"
                  rules="required|max:1000"
                  @input="e => setPurposeOfUse(e.target.value)"
                />
              </div>
              <div class="mb-24">
                <HeadlineFormTitle title="備考欄" class="mb-16" />
                <p class="minimal mb-16">
                  ご不明な点がある場合や、どうしても納品をお急ぎの場合等はこちらにご記入ください。（原則お振込いただいたことを確認してから3営業日前後でのご納品となりますので、お急ぎの場合でもご要望にお応えできない可能性がございます）
                </p>
                <InputFormTextArea
                  id="bulk_order_orderer_note"
                  :value="note"
                  placeholder="ご不明な点やご相談されたいことがある場合はこちらにご入力ください"
                  name="orderer_detail_form[note]"
                  autocomplete="off"
                  max-length="1000"
                  rules="max:1000"
                  @input="e => setNote(e.target.value)"
                />
              </div>
            </div>
          </div>
          <div class="bulk-order-orderer-detail-new__contents-container mb-16">
            <div class="bulk-order-orderer-detail-new__action">
              <div class="bulk-order-orderer-detail-new__action-message">
                <p class="minimal">
                  ※本サービスの対応は平日のみとなっております。週末や祝日にいただいたお申し込みは、翌営業日（平日）に確認させていただきますのでご了承ください。
                </p>
                <p class="minimal">
                  ※お申し込みいただいた内容に関して、メールでご連絡差し上げます。迷惑メールの対策、キャリアメール等、ドメイン指定を行っている場合、メールが受信できない場合がございますので「@giftee.co」を受信いただけるようにご設定をお願いいたします。
                </p>
              </div>
              <ButtonPrimary
                text="申し込み内容を確認する"
                type="submit"
                form="orderer-new-form"
                class="bulk-order-orderer-detail-new__submit-button mb-24"
                :disabled="!meta.valid || isSubmitting"
                @click-primary-button="onClickSubmit"
              />
              <TextLink
                class="text-link"
                type="button"
                @click="onClickBackLink"
              >
                ギフトカードリストに戻る
              </TextLink>
            </div>
          </div>
        </form>
      </Form>
      <TextLinkToTop
        class="bulk-order-orderer-detail-new__footer-container py-16"
      />
    </div>
  </div>
</template>

<script setup>
import PageHeadlineForBulkOrder from '~/src/js/customer/components/organism/bulk_personal_orders/PageHeadlineForBulkOrder.vue'
import Postcode from '../../../../api/Postcode'
import { storeToRefs } from 'pinia'
import { useBulkPersonalOrderOrdererDetailStore } from '~/src/js/customer/store/bulkPersonalOrderOrdererDetailStore'
import { ref } from 'vue'
import { isValidZipCode } from '@/src/js/customer/utils/zip-code-validator'
import * as Sentry from '@sentry/browser'
import { debounce } from 'lodash'
import HeadlineFormTitle from '~/src/js/customer/components/atoms/headlines/HeadlineFormTitle.vue'
import InputFormText from '@/src/js/customer/components/atoms/form/InputFormText.vue'
import InputFormTextArea from '@/src/js/customer/components/atoms/form/InputFormTextArea.vue'
import SelectForm from '@/src/js/customer/components/atoms/form/SelectForm.vue'
import ButtonPrimary from '@/src/js/customer/components/molecules/buttons/ButtonPrimary.vue'
import { Form } from 'vee-validate'
import ErrorMessages from '~/src/js/customer/components/atoms/form/ErrorMessages.vue'
import TextLink from '~/src/js/customer/components/atoms/text_links/TextLink.vue'
import TextLinkToTop from '~/src/js/customer/components/organism/bulk_personal_orders/TextLinkToTop.vue'
import BoxListAlert from '~/src/js/customer/components/molecules/box_list/BoxListAlert.vue'

const csrfToken = () =>
  document.querySelector('meta[name="csrf-token"]').content

// props
const props = defineProps({
  prefectures: {
    type: Array,
    required: true
  },
  errorMessages: {
    type: Array,
    required: false,
    default: () => []
  }
})

// data
const isLoadingPostCode = ref(false)
const isSubmitting = ref(false)

// stores
const store = useBulkPersonalOrderOrdererDetailStore()
const {
  lastName,
  firstName,
  email,
  emailConfirm,
  zipcode,
  prefectureId,
  address1,
  address2,
  phoneNumber,
  payerFullNameKana,
  purposeOfUse,
  note
} = storeToRefs(store)

const {
  setLastName,
  setFirstName,
  setEmail,
  setEmailConfirm,
  setZipcode,
  setPrefectureId,
  setAddress1,
  setAddress2,
  setPhoneNumber,
  setPayerFullNameKana,
  setPurposeOfUse,
  setNote
} = store

// methods
const onChangeZipcode = async e => {
  setZipcode(e.target.value)
  if (isValidZipCode(zipcode.value)) {
    await autoCompletionAddressByZipcode()
  }
}

const onClickBackLink = () => {
  window.location.href = '/bulk_order/gift_cards'
}

const onClickSubmit = () => {
  isSubmitting.value = true
  document.orderer_detail_new_form.submit()
}

const autoCompletionAddressByZipcode = debounce(async () => {
  isLoadingPostCode.value = true
  try {
    const addresses = await Postcode.getAddressesFromZipCode(zipcode.value, {
      fields: 'pref,city,town'
    })
    if (addresses.length === 0) {
      isLoadingPostCode.value = false
      return
    }
    const resPrefectureId = props.prefectures.find(
      p => p.name === addresses[0].pref
    ).id
    setPrefectureId(resPrefectureId)
    setAddress1(addresses[0].city + addresses[0].town)
  } catch (error) {
    // NOTE: 郵便番号検索が失敗した場合でも正しく動作させるためにSentryに通知だけしてスルーさせる
    Sentry.captureException(error)
  }
  isLoadingPostCode.value = false
}, 1000)
</script>

<style lang="scss" scoped>
.bulk-order-orderer-detail-new {
  &__container {
    padding-bottom: 40px;
  }

  &__contents-container {
    background-color: $white;
    margin-bottom: 16px;
    padding: 24px 16px;
  }

  &__header {
    &-container {
      display: flex;
      background-color: $white;
      margin-bottom: 16px;
      justify-content: center;
    }

    &-title {
      max-width: $base-contents-width;
      width: 100%;
      padding: 24px 16px;
    }
  }

  &__form {
    &-contents {
      max-width: $base-contents-width;
      width: 100%;
      padding: 0 16px;
      box-sizing: border-box;
      margin: auto;
      text-align: left;
    }
  }

  &__email-form-container {
    display: grid;
    gap: 16px;
  }

  &__address-form-container {
    display: grid;
    gap: 16px;
  }

  &__orderer-name {
    display: flex;
    gap: 17px;
  }

  &__submit-button {
    display: block;
    margin-inline: auto;
    max-width: 343px;
  }

  &__action {
    max-width: $base-contents-width;
    width: 100%;
    margin: auto;
    text-align: center;

    &-message {
      text-align: left;
      padding-bottom: 24px;
    }
  }

  &__footer-container {
    display: flex;
    justify-content: center;
  }

  .text-link {
    display: contents;
  }
}
</style>
